import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-cave",
  "use": "svg-cave-usage",
  "viewBox": "0 0 24.294 15.707",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.294 15.707\" fill=\"currentColor\" id=\"svg-cave\"><g transform=\"translate(-142.73 -112)\"><path d=\"m144.56 127.52h4.8728l1.3922-5.3102 0.92814 5.3102h4.4087l1.5082-8.4078 1.3922 8.1128h7.7732l-0.11603-3.0976-1.1602-3.6876-1.9723-3.6876-0.58009 4.4252-0.81213-5.4577-2.0883-2.5076-3.0165-1.0326h-2.0883l-0.58009 8.5553-1.1602-6.4902-0.34806 3.3926-1.2762-3.9827-2.5524 1.3276-3.0165 2.5076-2.4364 3.6876-0.6961 6.3427z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol